import classNames from "classnames"
import { BrewLogixLogo } from "components"
import { ScreenPaths } from "config/routing"
import Link from "next/link"
import type React from "react"

import { Box, useColorMode } from "@chakra-ui/react"

interface BrewLogixLogoProps {
    linkActive?: boolean
}

const BrewLogixLogoLink: React.FC<BrewLogixLogoProps> = ({ linkActive }) => {
    const { colorMode } = useColorMode()
    return (
        <Box w={[36, 40]}>
            <Link
                href={ScreenPaths.Dashboard}
                className={classNames(
                    !linkActive ? "pointer-events-none cursor-default" : "cursor-pointer"
                )}
                prefetch={false}
                style={{ width: "100%", display: "block" }}
            >
                <BrewLogixLogo colorMode={colorMode} />
            </Link>
        </Box>
    )
}

export default BrewLogixLogoLink
